export default "__VITE_ASSET__BCv8jh$1__"